import { Box, CircularProgress, LinearProgress, Sheet, Stack, Typography } from "@mui/joy";
import { Outlet, useLocation } from "react-router";
import HeaderLK from "../components/HeaderLK/HeaderLK";
import Sidebar from "../components/Sidebar/Sidebar";

import { motion } from "framer-motion";
import { useContext, useEffect, useRef } from "react";
import { LayoutContext } from "../context";



export default function LKPage() {
    const { account, loadDealList, loadListEvents } = useContext(LayoutContext);
    const location = useLocation();

    // useEffect(() => {
    //     // Выполняется каждый раз, когда изменяется текущий путь
    //     // console.log("Путь изменился на:", location.pathname);
    //     closeSidebar();
    // }, [location]);

    const scrollContainerRef = useRef(null); // Референс на блок для прокрутки

    
    return (
        <Box sx={{ display: 'flex', height: '100dvh' }}>
            <Sidebar/>

            <Box
                ref={scrollContainerRef}
                sx={{
                    overflow: 'auto',
                    height: '100%',
                    width: '100%',
                    pl: { xs: 1, md: 0 },
                    pr: 1
                }}
            >
                <HeaderLK />
                
                { (loadDealList || loadListEvents) && (
                    <Stack direction={'column'} spacing={1} sx={{ mx: 2, mt: 2 }}>
                        { loadDealList && (
                            <Sheet
                                variant="soft"
                                color="primary"
                                sx={{
                                    p: 1,
                                    mx: 2,

                                    borderRadius: 'lg',
                                    
                                }}
                            >
                                <Stack direction={'row'} spacing={2} alignItems={'center'}>
                                    <CircularProgress size={"sm"}/>
                                    <Typography color="primary" sx={{ lineHeight: 1.1, fontSize: "clamp(0.8rem, 2.5vw, 1rem)", fontWeight: 500 }}>
                                        Загружаю сделки Bitrix. Подождите чуть чуть))
                                    </Typography>
                                </Stack>
                            </Sheet>
                        )}

                        { loadListEvents && (
                            <Sheet
                                variant="soft"
                                color="success"
                                sx={{
                                    p: 1,
                                    mx: 2,

                                    borderRadius: 'lg',
                                    
                                }}
                            >
                                <Stack direction={'row'} spacing={2} alignItems={'center'}>
                                    <CircularProgress size={"sm"} color="success"/>
                                    <Typography color="success" sx={{ lineHeight: 1.1, fontSize: "clamp(0.8rem, 2.5vw, 1rem)", fontWeight: 500 }}>
                                        Загружаю события Календаря)
                                    </Typography>
                                </Stack>
                            </Sheet>
                        )}
                    </Stack>
                )}
                
                <Box
                    className="MainContent"
                    sx={{
                        // px: { xs: 2, md: 6 },
                        // mt: {
                        //     xs: 2,
                        //     md: 3,
                        // },
                        // pb: { xs: 2, sm: 2, md: 3 },
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        minWidth: 0,
                        gap: 1,
                        mb: 1,
                        height: "calc(100% - 78.61px)",
                    }}
                >
                    <motion.main
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 40 }}
                        style={{ height: "100%" }}
                    >
                        <Outlet context={{ scrollContainerRef }}/>
                    </motion.main>
                </Box>
            </Box>
        </Box>
    );
}